export default "__VITE_ASSET__97020869__"